import { Controller } from "@hotwired/stimulus"

// All Phases settings — the company's custom card labels. Rows are plain
// form fields (the page posts the whole card like the checklist template
// does); this only adds/removes rows and keeps each row's swatch in step
// with its colour select.
export default class extends Controller {
  static targets = ["list", "row", "template", "empty", "swatch"]

  // Same palette as BoardLabel::COLORS — written out so Tailwind sees
  // every class it has to compile.
  SWATCHES = {
    rose: "bg-rose-500", orange: "bg-orange-500", amber: "bg-amber-500",
    emerald: "bg-emerald-500", teal: "bg-teal-500", sky: "bg-sky-500",
    indigo: "bg-indigo-500", violet: "bg-violet-500", pink: "bg-pink-500",
    gray: "bg-gray-400"
  }

  addRow(event) {
    if (event) event.preventDefault()
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(row)
    row.querySelector('input[type="text"]')?.focus()
    this._refreshEmpty()
  }

  removeRow(event) {
    if (event) event.preventDefault()
    event.currentTarget.closest("[data-board-labels-target='row']")?.remove()
    this._refreshEmpty()
  }

  colorChanged(event) {
    const select = event.currentTarget
    const row = select.closest("[data-board-labels-target='row']")
    const swatch = row?.querySelector("[data-board-labels-target='swatch']")
    if (!swatch) return
    Object.values(this.SWATCHES).forEach(cls => swatch.classList.remove(cls))
    swatch.classList.add(this.SWATCHES[select.value] || this.SWATCHES.gray)
  }

  _refreshEmpty() {
    if (!this.hasEmptyTarget) return
    const any = this.listTarget.querySelectorAll("[data-board-labels-target='row']").length > 0
    this.emptyTarget.classList.toggle("hidden", any)
  }
}
